import React from "react";
import { Button } from "subframe/components/Button";

interface EscalationStats {
  total: number;
  actionNeeded: number;
  inProgress: number;
  resolved: number;
  dismissed: number;
}

interface EscalationsOverviewProps {
  stats: EscalationStats;
  onViewAll: () => void;
}

export const EscalationsOverview: React.FC<EscalationsOverviewProps> = ({
  stats,
  onViewAll,
}) => {
  return (
    <div className="flex w-full lg:w-112 flex-none flex-col items-center self-stretch rounded-lg bg-default-background px-3 sm:px-4 py-4">
      <div className="flex w-full flex-col items-center gap-4 sm:gap-6">
        <div className="flex w-full items-center justify-between">
          <span className="line-clamp-1 text-subheader font-subheader text-default-font">
            Escalations
          </span>
          <div className="flex h-6 items-center gap-1 rounded-md border border-solid border-neutral-border bg-white px-2">
            <span className="whitespace-nowrap text-label-bold font-label-bold text-neutral-700">
              {stats.total} total
            </span>
          </div>
        </div>
        <div className="flex w-full flex-col sm:flex-row items-center justify-center gap-4 sm:gap-2">
          <div className="flex w-full sm:w-auto items-center justify-center gap-2 sm:gap-4">
            <div className="flex w-20 sm:w-24 flex-none flex-col items-center">
              <span className="line-clamp-1 text-section-header font-section-header text-error-700">
                {stats.actionNeeded}
              </span>
              <span className="line-clamp-1 text-label font-label text-error-700 text-center">
                Action needed
              </span>
            </div>
            <div className="flex w-20 sm:w-24 flex-none flex-col items-center">
              <span className="line-clamp-1 text-section-header font-section-header text-warning-700">
                {stats.inProgress}
              </span>
              <span className="line-clamp-1 text-label font-label text-warning-700 text-center">
                In-progress
              </span>
            </div>
          </div>
          <div className="hidden sm:flex w-px flex-none flex-col items-center gap-2 self-stretch bg-neutral-border" />
          <div className="flex w-full sm:w-auto items-center justify-center gap-2 sm:gap-4">
            <div className="flex w-20 sm:w-24 flex-none flex-col items-center">
              <span className="line-clamp-1 text-section-header font-section-header text-success-700">
                {stats.resolved}
              </span>
              <span className="line-clamp-1 text-label font-label text-success-700 text-center">
                Resolved
              </span>
            </div>
            <div className="flex w-20 sm:w-24 flex-none flex-col items-center">
              <span className="line-clamp-1 text-section-header font-section-header text-default-font">
                {stats.dismissed}
              </span>
              <span className="line-clamp-1 text-label font-label text-default-font text-center">
                Dismissed
              </span>
            </div>
          </div>
        </div>
        <Button
          disabled={true}
          variant="brand-secondary"
          onClick={onViewAll}
          className="w-full sm:w-auto"
        >
          View all escalations
        </Button>
      </div>
    </div>
  );
}; 